/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Claim creation model.
 */
export interface CreateClaimRequest { 
    clientId: number;
    caseId: number;
    templateId: number;
    name: string;
}

